module.exports = __webpack_public_path__ + "static/media/ic_show_track_hover.7fc31178.svg";